import cookieCommons from './cookieCommons';

// không biết đặt tên kiểu gì :D? nên đừng động vào, call me (Phuong) if need maintain
export const parseProductsArray = (intiArray: Array<any>) => {
  let idAndNameArray: Array<any> = [];
  let valueArray: Array<any> = [];
  let logoArray: Array<any> = [];

  let id: number = 0;

  intiArray.forEach((element: any) => {
    element['keywords'].forEach((eachKey: string) => {
      idAndNameArray.push({ id: id + '', name: eachKey, addedScore: 0.0 });
    });
    valueArray.push(element['value']);
    logoArray.push(element['logo']);
    id++;
  });

  // console.log({
  //   idAndNameArray,
  //   valueArray,
  // });

  return {
    idAndNameArray,
    valueArray,
    logoArray,
  };
};

export const checkEduMail = (email?: string) => {
  const userEmail: string = email || cookieCommons.getUserEmail() || '';
  return userEmail?.includes('.edu.');
};

export const deepClone = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value));
};
